import Swiper from 'swiper/bundle';
//import 'swiper/swiper-bundle.css';

const createSwiper = (container, { direction = 'horizontal', loop = true, autoHeight = false, pagination = true, navigation = true, breakpoints = {} }) => {
    return new Swiper(container, {
        direction: direction,
        loop: loop,
        autoHeight: autoHeight,
        pagination: pagination ? {
            el: '.swiper-pagination',
            clickable: true,
        } : false,
        navigation: navigation ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        } : false,
        breakpoints: breakpoints
    });
};

export default createSwiper;
